import React from "react";
import { Link, Outlet, useLocation, useNavigate } from "react-router-dom";
import logo from "../../assets/images/logo.png";

const SuperAdminLayout = () => {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  const handleLogout = () => {
    localStorage.clear();
    navigate("/login");
  };

  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <header className="bg-primary text-white px-6 py-3 flex items-center justify-between shadow">
        <div className="flex items-center gap-4">
          <img src={logo} alt="Dhanvantaree" className="h-10 w-auto" />
          <span className="text-sm font-semibold tracking-wide uppercase opacity-75">
            Super Admin
          </span>
        </div>
        <nav className="flex items-center gap-6">
          <Link
            to="/superadmin"
            className={`text-sm font-medium ${
              pathname === "/superadmin"
                ? "text-white underline underline-offset-4"
                : "text-white/70 hover:text-white"
            }`}
          >
            Clinics
          </Link>
          <button
            onClick={handleLogout}
            className="text-sm font-medium text-white/70 hover:text-white"
          >
            Logout
          </button>
        </nav>
      </header>
      <main className="flex-1 p-6 max-w-7xl mx-auto w-full">
        <Outlet />
      </main>
    </div>
  );
};

export default SuperAdminLayout;
